export const SETTINGS_SAML_FETCH = 'SETTINGS_SAML_FETCH';
export const SETTINGS_SAML_FAIL = 'SETTINGS_SAML_FAIL';
export const SETTINGS_SAML_SUCCESS = 'SETTINGS_SAML_SUCCESS';
export const SET_SETTINGS_SAML_FIELD = 'SET_SETTINGS_SAML_FIELD';
export const SET_SETTINGS_SAML_RESET = 'SET_SETTINGS_SAML_RESET';
